<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-01-26 14:32:44
 * @FilePath: \crm-product\found\views\mdm\views\user_pending\table.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '@/found/components/table_page';
// 新增用户
import addUser from '../user_management/form/add_user/index';
import request from '../../../../utils/request';

export default {
  name: 'user_pending',
  extends: TablePage,
  data() {
    return {};
  },
  components: {
    addUser,
  },
  methods: {
    // 控制按钮显示
    clickVisible({ row, val: { code } }) {
      const { status } = row;
      if (code === 'process_immediately' && status !== '0') {
        return false;
      }
      return true;
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      if (val.code === 'process_immediately') {
        this.formName = 'addUser';
        this.formConfig = { ...row, code: val.code };
        if (row.businessType === '0') {
          this.modalConfig.title = '入职';
        } else if (row.businessType === '1') {
          this.modalConfig.title = '调岗';
        } else if (row.businessType === '2') {
          this.modalConfig.title = '离职';
        } else {
          this.modalConfig.title = '企业用户';
        }
        this.openFull();
      } else if (val.code === 'cancellation') {
        if (!this.selection.length) {
          this.$message.error('请选择至少一条数据！');
          return false;
        }
        const names = this.selectRow.map((v) => v.fullName);
        this.$confirm(`否确认作废以下人员入职信息：${names.join('，')}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          request
            .post('/mdm/mdmhrusersynrecord/disable', this.selection)
            .then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.getList();
                this.clearSelection();
              }
            });
        });
      }
    },
  },
  created() {
    this.getConfigList('main_list');
  },
};
</script>
